import React from 'react';

interface PublicationYearProps {
    year: number | string;
    children: React.ReactNode;
    isMobile?: boolean;
    isLastYear?: boolean;
}

const PublicationYear: React.FC<PublicationYearProps> = ({
    year,
    children,
    isMobile = false,
    isLastYear = false,
}) => {
    // Check if children exists and is not empty
    const hasChildren = React.Children.count(children) > 0;

    // Don't render if no children
    if (!hasChildren) {
        return null;
    }

    return (
        <>
            <h2
                className={`text-textGrey font-condensed text-left text-2xl mb-2 ${
                    isMobile ? 'mx-10' : 'pl-4'
                } ${year !== 2025 ? 'mt-4' : ''}`}
            >
                {year}
            </h2>
            <ul
                className={`text-textGrey text-lg text-left font-condensed font-extralight list-none ${
                    isMobile
                        ? 'text-md pl-6 mx-10'
                        : 'max-w-6xl'
                }`}
            >
                {children}
            </ul>
            {!isLastYear && !isMobile && <br />}
        </>
    );
};

export default PublicationYear;